class Subs2ColsDesplegables {
    constructor(args = { sectionsContainer: document }) {
        this.sectionsContainer = args.sectionsContainer;
        this.sections = this.sectionsContainer.getElementsByClassName("subs-2-cols-desplegable");
        if (this.sections[0]) {
            this.init();
        }
    }

    init() {
        Array.from(this.sections).forEach((section) =>
            this.initDesplegables(section)
        );
    }

    initDesplegables(section) {
        const colRight = section.querySelector('.col-right');
        
        if (colRight) {
            const handlers = colRight.querySelectorAll('.container-handler');

            handlers.forEach(handler => {
                handler.addEventListener('click', () => {
                    const row = handler.closest('.row');

                    if (row.classList.contains('active')) {
                        row.classList.remove('active');
                    } else {
                        const allRows = colRight.querySelectorAll('.row');
                        allRows.forEach(row => {
                            row.classList.remove('active');
                        });
                        row.classList.add('active');
                    }
                });
            });
        }
    }
}

export default Subs2ColsDesplegables;
